import { useRef } from 'react';
import useEventListener from './useEventListener.js';
// hook accepts a selector to exclude from focus tracking
export default function useLastFocusedElement(excludedSelector) {
  const lastFocusedElementRef = useRef(null);

  useEventListener(document, 'focusin', handleFocusIn);
  useEventListener(document, 'focusout', handleFocusOut);
  function handleFocusIn(event) {
    const target = event.target;
    if (!target.closest(excludedSelector)) {
      lastFocusedElementRef.current = target;
    }
  }

  function handleFocusOut(event) {
    const target = event.relatedTarget;
    if (!target || !target.closest(excludedSelector)) {
      lastFocusedElementRef.current = null;
    }
  }

  return lastFocusedElementRef;
}
